export class DeliveryRangeModel {
    ongoing: boolean;
    start: Date;
    end: Date;
    timezone: string;
}
